module.exports = __webpack_public_path__ + "static/media/HomeRunSports-Logo-Black-Red.cf49ea9c.png";